<template>
    <div class="dealer-confirmation">
      <div class="dealer-main">
        <img :src="stateInfo[currentState].imgUrl" class="dealer-img">
        <p class="txt">{{ stateInfo[currentState].txt }}</p>
      </div>
      <!-- 待确认 -->
      <div class="dealer-center" v-if="stateInfo[currentState].state == '01'">
        <div class="dealer-qrcode">
          <div class="qrcode" id="qrcode"></div>
        </div>
        <div class="dealer-notes">
          <p>说明：</p>
          <p>请将以上二维码出示至指定经销商，由经销商操作确认后可继续完成分期</p>
        </div>
      </div>
      <!-- 已同意 & 已拒绝 -->
      <div class="dealer-center" v-else>
        <div class="operate-info">
          <div class="operate-item">
            <div class="key">操作人</div>
            <div class="val">{{ productInfo.loanDealer.managerName }}</div>
          </div>
          <div class="operate-item">
            <div class="key">操作时间</div>
            <div class="val">{{ productInfo.auditTime }}</div>
          </div>
        </div>
      </div>
      <!-- 
        待确认：刷新
        已同意：下一步
        已拒绝：返回
       -->
      <div class="dealer-btn">
        <button class="btn" @click="nextStep">{{ stateInfo[currentState].btnTxt }}</button>
      </div>

    </div>
</template>
<script>
import Vue from 'vue'
import { Button } from 'vant'
import QRCode from 'qrcodejs2';
import { userLcApplGooodsApi } from '@/apis/kdb';
import { getUserFrontBasicMsgApi } from '@/apis/userCenter'
import { Toast } from 'vant';
import wx from 'weixin-js-sdk';

export default {
  components: {},
  data() {
    return {
      stateInfo:[
        {
          state: '01',
          txt: '待确认',
          imgUrl: require('@/assets/images/kdb/delar-confirm.png'),
          btnTxt: '刷新'
        },
        {
          state: '02',
          txt: '已同意',
          imgUrl: require('@/assets/images/kdb/delar-agree.png'),
          btnTxt: '下一步'
        },
        {
          state: '03',
          txt: '已拒绝',
          imgUrl: require('@/assets/images/kdb/delar-refuse.png'),
          btnTxt: '返回'
        }
      ],
      // 当前状态 0：待确认 1：已同意 2：已拒绝
      currentState: 0,
      productInfo: {},
      params: {},
      isRealNameCheck: false
    }
  },
  async created() {
    this.params = this.$route.query
    this.getUserFrontBasicMsg()
    await this.userLcApplGooodsFun(this.params)
    this.$nextTick(() => {
      if(this.currentState == 0) {
        const qrcode = new QRCode(document.getElementById("qrcode"), {
            text: `${window.location.origin}/dealerList?id=${this.productInfo.id}&appId=${this.$store.state.user.queryParams.appId}`,
            render:  "svg",
            width: 128,
            height: 128,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
        });
      }
    })
  },
  methods: {
    async userLcApplGooodsFun(){
      const loadingToast = Toast.loading({
        message: '查询中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let res = await userLcApplGooodsApi({...this.params, loanTyp: 'kdb_001'})
        if (res && res.code == 200) {
            this.productInfo = res.data
            console.log(this.productInfo);
            // status 0创建，1待确认，2已同意，3已拒绝，4发起借款
            if(this.productInfo.status == '0' || this.productInfo.status == '1') {
              this.currentState = 0
            } else if(this.productInfo.status == '2') {
              this.currentState = 1
            } else if(this.productInfo.status == '3'){
              this.currentState = 2
            }
            try {
              this.$store.commit('SET_LOANNO', this.productInfo.lcAppl.loanNo)
              this.$store.commit('SET_APPLY_SEQ', this.productInfo.lcAppl.seqNo)
              this.$store.commit('SET_NOTARIZATION_APPLY_INFO', {
                weiXinSchemaUrl: this.productInfo.weiXinSchemaUrl || '', // inSts=130 有值 微信 $chema 调起小程序Url，androidNios 系统直接打开可以拉起小程序
                weiXinHttpUrl: this.productInfo.weiXinHttpUrl || '', // inSts=130 微信 H5 调起 url，系统浏览器使用这个 url，可以直接拉起小程序
                expireTime: this.productInfo.expireTime || '', //inSts=130 有值，失效时间,秒级时间戳
                navigateParam: this.productInfo.navigateParam || ''
              })
            } catch (error) {}
            
            loadingToast.clear()
        } else {
          this.$common.toast(res.msg)
        }
      } catch (error) {}
    },
    async nextStep(){
      if(this.productInfo.status == '0' || this.productInfo.status == '1') {
        await this.userLcApplGooodsFun()
      } else if(this.productInfo.status == '2' || this.productInfo.status == '4') {
        // 去公证
        this.$router.push('/notarizationApply')
      }else {
        // 判断是否在微信环境中
        if (typeof wx !== 'undefined' && wx.miniProgram) {
            // 返回卡电宝小程序
            wx.miniProgram.reLaunch({
              url: `/pages/new/main/index?appId=${process.env.VUE_APP_KDB_APPID}`
            })
        } else {
            console.log('请在微信环境中打开');
        }
      }
    },
    getUserFrontBasicMsg() {
      getUserFrontBasicMsgApi()
        .then((res) => {
          if (res.code === 200) {
            this.isRealNameCheck = res.data.realNameCheck
          }
        })
        .catch(() => {})
    },
  }
}
</script>
<style lang="less" scoped>
.dealer-confirmation {
    box-sizing: border-box;
    height: 100vh;
    background: #f5f6fa;
    padding: 0.4rem;
    position: relative;
    .dealer-main {
      text-align: center;
      margin-top: 0.06rem;
      position: relative;
      .txt {
        position: absolute;
        bottom: 0.70rem;
        width: 100%;
        font-weight: 500;
        font-size: 0.32rem;
        line-height: 0.44rem;
        color: #333333;
      }
      .dealer-img {
        width: 4.52rem;
        height: 4rem;
      }
    }
    .dealer-center {
      margin-bottom: 2.3rem;
      .dealer-qrcode {
        text-align: center;
        margin-bottom: 0.46rem;
        .qrcode {
          display: flex;
          justify-content: center;
        }
        img {
          width: 2.4rem;
          height: 2.43rem;
          border-radius: 0.24rem;
          border: 0.14rem solid #F4F4F4;
          margin: 0 auto;
        }
      }
      .dealer-notes {
        p {
          font-weight: 500;
          font-size: 0.32rem;
          color: #333333;
          line-height: 0.44rem;
          margin-bottom: 0.08rem;
          &:last-child {
            font-size: 0.3rem;
            margin-bottom: 0;
          }
        }
      }

      .operate-info {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0rem 0rem 0.3rem 0rem rgba(0,0,0,0.08);
        border-radius: 0.08rem;
        
        .operate-item {
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.4rem 0rem;
          font-weight: 500;
          font-size: 0.3rem;
          color: #333333;
          line-height: 0.42rem;
          width: calc(100% - 0.8rem);
          &:first-child {
            border-bottom: 1px solid #E7E7E7;
          }
        }
      }
    }
    .dealer-btn {
      position: absolute;
      bottom: 2.2rem;
      width: calc(100% - 0.8rem);
      .btn {
        width: 100%;
        height: 0.88rem;
        line-height: 0.88rem;
        text-align: center;
        background: #4d7bfe;
        border-radius: 0.44rem;
        color: #ffffff;
        border: none;
      }
    }
    
}
</style>